// Конфигурация переменных окружения
// В тестовом окружении можно использовать моки

interface EnvConfig {
  VITE_API_SERVER: string
  [key: string]: string | boolean
}

// Проверка тестового окружения (Jest)
const isTestEnv =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'test'

export const getEnvConfig = (): EnvConfig => {
  if (isTestEnv) {
    // Тестовое окружение - используем process.env
    return {
      VITE_API_SERVER:
        process.env.VITE_API_SERVER || 'http://37.230.115.124:5000',
    } as EnvConfig
  }

  // Production/development - используем import.meta.env из Vite напрямую
  return {
    VITE_API_SERVER:
      import.meta.env.VITE_API_SERVER || 'http://37.230.115.124:5000',
    ...import.meta.env,
  } as EnvConfig
}
